// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging } from "firebase/messaging"; // Bu satır zaten vardı
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDZyeTUN_FkXDC_OHp56nSMt9sLBZEtUmw",
  authDomain: "randevupp-mudamu.firebaseapp.com",
  projectId: "randevupp-mudamu",
  storageBucket: "randevupp-mudamu.firebasestorage.app",
  messagingSenderId: "983388371638",
  appId: "1:983388371638:web:ab5cd85c6852e3963cc417",
  measurementId: "G-SN4M5RMQZB",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig); //
const analytics = getAnalytics(app); //

// --- EKSİK KISIM BURASIYDI ---
// Messaging servisini başlat ve export et
export const messaging = getMessaging(app);
// --- DÜZELTME SONU ---

// app'i de default olarak export edebilirsiniz (opsiyonel)
export default app;
